import { useMemo } from 'react';
import { resolveTenantIdFromToken, useTypedSelector } from '@circuitry-ai/doc-data';

/** The signed-in user as AI Insight needs them: token, tenant (from the token) and who they are. */
export function useViewer() {
  const token = useTypedSelector((state) => state.auth.token);
  const details = useTypedSelector(
    (state) => state.auth.user?.details as { sub?: string; name?: string; email?: string } | null
  );
  const tenant = useMemo(() => (token ? resolveTenantIdFromToken(token) : ''), [token]);
  const sub = details?.sub ?? '';
  return { token, tenant, sub, name: details?.name || details?.email || sub };
}
